// extracted by mini-css-extract-plugin
export default {"postsBlock":"PostList_postsBlock__CMixF"};